import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// 404 page (9/4). Before this, ANY unknown path — /banana, /september-2026,
// a stale link — rendered the homepage with the homepage's canonical, so the
// site offered search engines unlimited duplicates of itself. The noindex tag
// is the part that matters: Netlify's SPA catch-all has to answer 200 for
// client routing to work, so the status stays soft, but the page is now
// explicitly excluded from the index and says so to the visitor.
export default function NotFound() {
  return (
    <div style={{ maxWidth: '560px', margin: '0 auto', padding: '10px 20px 80px', textAlign: 'center' }}>
      <Helmet>
        <title>Page not found | Film Revival NYC</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <h1 style={{ fontFamily: "'Cinzel', Georgia, serif", fontSize: '1.6rem', letterSpacing: '1px', margin: '0 0 12px' }}>
        Page not found
      </h1>
      <p style={{ color: '#6b6255', fontSize: '0.95rem', lineHeight: 1.6, margin: '0 0 22px' }}>
        That page doesn't exist. The calendar is the best place to start.
      </p>
      <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
        <Link to="/" style={{ background: '#8b6914', color: '#fff', borderRadius: '6px', padding: '10px 20px', textDecoration: 'none', fontSize: '0.9rem' }}>
          See what's playing
        </Link>
        <Link to="/venues" style={{ border: '1px solid #d4cec4', color: '#2a2520', borderRadius: '6px', padding: '10px 20px', textDecoration: 'none', fontSize: '0.9rem' }}>
          Browse venues
        </Link>
      </div>
    </div>
  );
}
